import { ReplacementFilesComponentLearnersDto, Resubmitter } from '@cambridgeassessment/lib-ee-commons';
import { useAuth } from 'oidc-react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { setIsLinkedCandidateModalOpen } from '../../../../../store/replacementFiles/actions';
import { setLearnerReplacementStatus } from '../../../../../store/replacementFiles/thunks';
import { StyledCentralDialog } from './FileAssociationModal.styles';

interface Props {
  isShown: boolean;
  selectedLearner: {
    learnerBid: ReplacementFilesComponentLearnersDto;
    entryIndex: number;
    componentIndex: number;
    val: boolean;
  } | null;
}

const FileAssociationModal: React.FC<Props> = ({ isShown, selectedLearner }) => {
  const dispatch = useDispatch();

  const { associatedLearners } = useSelector((state: RootState) => state.replacementFiles);
  const [openModal, setOpenModal] = useState(false);
  const { userData } = useAuth();
  const { selectedRole } = useSelector((state: RootState) => state.userData);

  useEffect(() => {
    if (isShown) {
      setOpenModal(true);
    }
  }, [isShown, associatedLearners]);

  const handleModalClose = () => {
    dispatch(setIsLinkedCandidateModalOpen(false));
    setOpenModal(false);
  };

  const handleEnableReplacement = (isMultiple: boolean) => {
    if (!selectedLearner) return;

    const resubmitter: Resubmitter = {
      name: userData?.profile.name,
      email: userData?.profile.email,
      role: selectedRole?.name,
    };

    dispatch(
      setLearnerReplacementStatus(
        selectedLearner.learnerBid,
        selectedLearner.componentIndex,
        selectedLearner.entryIndex,
        resubmitter,
        isMultiple,
      ),
    );
    handleModalClose();
  };

  const learnersForModal = [
    ...new Set(associatedLearners.map((learner) => learner.learnerNumber?.toString().padStart(4, '0'))),
  ]
    .sort()
    .join(', ');

  const renderModalBody = () => (
    <>
      <p>
        The candidate you have enabled for needing replacement files submitted, has one or more files associated with
        other candidates.
      </p>
      <p>Do you want to enable the ‘linked’ candidates as requiring replacement files also?</p>
      <p>Linked candidates are: {learnersForModal}</p>
    </>
  );

  return (
    <StyledCentralDialog
      open={openModal}
      dataQaId='file-association-modal'
      disableEnforceFocus
      disableAutoFocus
      title={'Candidate has one or more files linked with multiple candidates'}
      buttons={[
        {
          variant: 'text',
          text: 'Enable for candidate',
          onClick: () => handleEnableReplacement(false),
        },
        {
          text: 'Enable for linked',
          onClick: () => handleEnableReplacement(true),
        },
      ]}
    >
      {renderModalBody()}
    </StyledCentralDialog>
  );
};

export default FileAssociationModal;
